import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.find";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from "@/config";
import { pests } from "@/api/api_url";
import { renderFormMixins } from "@/mixins/renderFormMixins";
import { get_type, catch_fear_timelist, deviceinfo_list, product_list } from "@/api/jingxiaoshang";
import Editor from "@/components/editor";
import { getToken, formatYMD } from "@/libs/util";
import { jingxiaoshang } from "@/api/api_url";
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    var _formModel, _formRules;

    return {
      tabaleValue: "1",
      hasUpload: true,
      defaultFileList: [],
      headers: {
        Authorization: getToken()
      },
      extraData: {
        model_code: "",
        chan_num: 0,
        hardware_ver: "",
        project_code: "",
        firmware_ver: ""
      },
      fileName: "filename",
      firmware_typeData: [{
        firmware_type: 0,
        firmware_type_name: "请求升级"
      }, {
        firmware_type: 1,
        firmware_type_name: "强制升级"
      }],
      tableloading: false,
      modelcodeData: [],
      //数据
      hardware_verData: [],
      project_codeData: [],
      path: [],
      product_type_code: null,
      reqBase: {},
      formModel: (_formModel = {
        project_code: "",
        hardware_ver: "",
        is_file: 1,
        id: "",
        //产品型号
        product_id: "",
        //产品id
        model_code: null,
        change_log: null,
        firmware_ver: null,
        firmware_md5: "",
        firmware_type: 1,
        firmware_url: null,
        fragmentation: 2,
        sdk: "",
        zh: "",
        en: ""
      }, _defineProperty(_formModel, "firmware_md5", null), _defineProperty(_formModel, "byte", null), _defineProperty(_formModel, "chan_num", 0), _formModel),
      spinShow: false,
      formRules: (_formRules = {
        model_code: [{
          required: true,
          type: "string",
          message: this._vm.$t('产品型号不能为空'),
          trigger: "change"
        }],
        hardware_ver: [{
          required: true,
          type: "string",
          message: this._vm.$t('硬件版本号不能为空'),
          trigger: "change"
        }],
        project_code: [{
          required: true,
          type: "string",
          message: this._vm.$t('项目号不能为空'),
          trigger: "change"
        }],
        firmware_ver: [{
          required: true,
          type: "string",
          message: this._vm.$t('固件版本号不能为空'),
          trigger: "change"
        }]
      }, _defineProperty(_formRules, "firmware_ver", [{
        required: true,
        message: this._vm.$t('固件版本号不能为空'),
        trigger: "change"
      }, {
        pattern: /^\d+(\.\d+){3}\d{1,2}_\d{6}$/,
        message: this._vm.$t('请输入正确的固件版本号'),
        trigger: "change"
      }]), _defineProperty(_formRules, "firmware_type", [{
        required: true,
        type: "number",
        message: this._vm.$t('升级方式不能为空'),
        trigger: "change"
      }]), _defineProperty(_formRules, "firmware_url", [{
        required: true,
        type: "string",
        message: this._vm.$t('固件版本不能为空'),
        trigger: "change"
      }]), _formRules),
      nodeList: [],
      tempData: {} //等待提交的临时数据

    };
  },
  props: {
    _vm: {},
    edit: {
      type: Boolean,
      default: false
    },
    hasDetails: {
      type: Boolean,
      default: false
    },
    $store: {},
    setData: {},
    model_codeData: {},
    hardware_verData: {},
    // project_codeData: {},
    parent_code: {},
    parent_name: {}
  },
  components: {
    Editor: Editor
  },
  computed: {
    actionUrl: function actionUrl() {
      var result = "";

      if (process.env.NODE_ENV === "development") {
        result = config.baseUrl.dev + "" + jingxiaoshang.uploadfirmwarever;
      } else if (process.env.VUE_APP_BUILD === "production") {
        result = config.baseUrl.pro + "" + jingxiaoshang.uploadfirmwarever;
      } else {
        result = config.baseUrl.alp + "" + jingxiaoshang.uploadfirmwarever;
      }

      return result;
    },
    projectCode: function projectCode() {
      return this.$store.state.user.projectCode;
    }
  },
  methods: {
    clearinfo: function clearinfo() {
      alert(123);
    },
    handleContractSuccess: function handleContractSuccess(res, file) {
      var vm = this;
      this.uploading = false;

      if (res.result === 0) {
        this.$set(this.formModel, "firmware_md5", res.body.md5); //let url=this.getRoot+res.body.firmware_url;

        var url = res.body.firmware_url;
        this.$set(this.formModel, "firmware_url", url);
        this.$set(this.formModel, "sdk", url);
        this.$set(this.formModel, "byte", res.body.firmware_size);
      } else {
        // console.log("1000")
        // vm.$Message.error(vm.errorCode[res.result]);
        var msg = res.errorMsg;
        this.clearFirmware();
        vm.$Message.error(msg);
      }
    },
    tabChange: function tabChange(name) {
      this.$set(this, "tabaleValue", name);
    },
    changeDescZh: function changeDescZh(html, text) {
      if (text === "") {
        this.$set(this.formModel, "zh", text);
      } else {
        this.$set(this.formModel, "zh", html);
      }
    },
    changeDescEn: function changeDescEn(html, text) {
      if (text === "") {
        this.$set(this.formModel, "en", text);
      } else {
        this.$set(this.formModel, "en", html);
      }
    },
    handleContractBeforeUpload: function handleContractBeforeUpload(file) {
      var isLt100M = file.size / 1024 / 1024 <= 120;

      if (!isLt100M) {
        this.clearFirmware();
        this.$Message.error("固件大小不可超过120M");
        return true;
      }

      if (!this.hasUpload) {
        this.$refs.uploadFile.clearFiles();
        this.$set(this.formModel, "firmware_md5", null);
        this.$set(this.formModel, "firmware_url", null);
      } else {
        console.log("检测中");
        this.checkupload();
        return false;
      }
    },

    /**
     * 改变后需要重新上传
     */
    clearFirmware: function clearFirmware() {
      //  alert(123)
      this.defaultFileList.splice(0);
      this.$set(this.formModel, "firmware_url", "");
    },
    modelChange: function modelChange(value) {
      var selectedObject = this.model_codeData.find(function (item) {
        return item.model_code === value;
      }); // console.log('对应的对象:', selectedObject);

      this.product_type_code = selectedObject.product_type_code;
      this.$set(this.extraData, "model_code", value);
      this.checkupload();
      this.clearFirmware();
      this.getxmhData();
    },
    firmwareVerChange: function firmwareVerChange(value) {
      this.checkupload();
      this.$set(this.extraData, "firmware_ver", this.formModel.firmware_ver);
      this.clearFirmware();
    },
    projectcodeChange: function projectcodeChange(value) {
      this.checkupload();
      this.$set(this.extraData, "project_code", this.formModel.project_code);
      this.clearFirmware();
    },
    hardwareverChange: function hardwareverChange(value) {
      this.checkupload();
      this.$set(this.extraData, "hardware_ver", this.formModel.hardware_ver);
      this.clearFirmware();
      this.getxmhData();
    },
    //检查上传
    checkupload: function checkupload(callback) {
      var fieldValidate = ["model_code", "firmware_ver", "hardware_ver", "project_code"];

      var _self = this;

      Promise.all(fieldValidate.map(function (item) {
        var p = new Promise(function (resolve, reject) {
          _self.$refs[_self.refName].validateField(item, function (error) {
            resolve(error);
          });
        });
        return p;
      })).then(function (data) {
        console.log("测试数据", data);

        var _data = data.filter(function (item) {
          return item;
        });

        if (!_data.length) {
          _self.hasUpload = false;

          if (callback) {
            callback();
          }
        } else {
          _self.hasUpload = true;
        }
      });
    },
    //获取第三个项目号
    getxmhData: function getxmhData() {
      var _this = this;

      console.log("aaabb");
      this.formModel.project_code = null;

      if (this.product_type_code && this.formModel.hardware_ver) {
        product_list({
          page: 1,
          page_size: -1,
          hardware_ver: this.formModel.hardware_ver,
          product_type_code: this.product_type_code
        }).then(function (res) {
          _this.project_codeData = res.body;
        });
      }
    },

    /**
     * 单个删除
     */
    delDevice: function delDevice(row) {
      for (var i = 0; i < this.data2.length; i++) {
        var list = this.data2[i];

        if (row.device_id === list.device_id) {
          //同时删除临时对象中的数据
          var index = this.tempData[list.node_code].indexOf(list.device_id);

          if (index > -1) {
            this.tempData[list.node_code].splice(index, 1);
          }

          this.data2.splice(i, 1);
          break;
        }
      }
    },
    clickNode: function clickNode(data) {
      var _this2 = this;

      this.data1.splice(0);
      this.tableloading = true;
      this.$set(this.reqBase, "page", 1);
      this.$set(this.reqBase, "page_size", 2000);
      this.$set(this.reqBase, "node_code", data.node_code);
      this.$set(this.reqBase, "project_code", this.projectCode);
      deviceinfo_list(this.reqBase).then(function (res) {
        _this2.tableloading = false;

        if (res.result === 0) {
          var _this2$data;

          var list = res.body.list || [];

          (_this2$data = _this2.data1).push.apply(_this2$data, _toConsumableArray(list));
        } else {}
      });
    },
    addTimeFun: function addTimeFun() {
      this.$refs.addTime.showModal(true);
    },
    createTree: function createTree(data) {
      for (var i in data) {
        var list = data[i];
        list["value"] = list.cate_code;
        list["label"] = list.cate_name;

        if (list.children && list.children.length > 0) {
          this.createTree(list.children);
        }
      }
    },
    getTreeNodeData: function getTreeNodeData(callback) {
      var _this3 = this;

      this.spinShow = true;
      this.nodeList.splice(0);
      patrolcateGetAllCate({
        project_code: this._vm.$store.state.user.projectCode
      }).then(function (res) {
        _this3.spinShow = false;

        if (res.result === 0) {
          var _this3$nodeList;

          var data = res.body;

          _this3.createTree(data);

          (_this3$nodeList = _this3.nodeList).push.apply(_this3$nodeList, _toConsumableArray(data));

          if (callback) {
            callback(_this3.nodeList);
          }
        } else {}
      });
    },
    init: function init() {},

    /**
     * 获取节点所在数组的位置
     */
    getTreeNodeArray: function getTreeNodeArray(tree, func, path) {
      if (!tree) return [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = tree[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var data = _step.value;
          // 这里按照你的需求来存放最后返回的内容吧
          //这里的date是表示我是根据date去查询父级的，你可以修改成你的需求，其他不变
          path.push(data.node_code);
          if (func(data)) return path;

          if (data.children) {
            var findChildren = this.getTreeNodeArray(data.children, func, path);
            if (findChildren.length) return findChildren;
          }

          path.pop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return [];
    },

    /**
     * 返回数据
     */
    setTimeRule: function setTimeRule(timeObj) {
      this.$set(this.formModel.plan_interval, "plan_start", timeObj.plan_start);
      this.$set(this.formModel.plan_interval, "plan_end", timeObj.plan_end);
      this.$set(this.formModel.plan_interval, "interval", timeObj.interval);
      this.$set(this.formModel, "plan_accuracy", timeObj.plan_accuracy);
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$nextTick(function () {
      if (_this4.edit) {
        Object.assign(_this4.formModel, _this4.setData);

        _this4.checkupload();
      } else {
        _this4.piecesDisabled = true;
      }
    }); // this.get_type();

    console.log("ccc", this.setData);

    if (this.edit) {
      if (this.setData) {
        console.log(this.formModel);
      }
    } else {}
  },
  created: function created() {
    var _this5 = this;

    if (this.setData !== undefined) {
      console.log("aaaaa", this.setData);
      Object.assign(this.formModel, this.setData);
      this.$set(this.extraData, "model_code", this.setData.model_code);
      this.$set(this.extraData, "hardware_ver", this.setData.hardware_ver);
      this.$set(this.extraData, "project_code", this.setData.project_code);
      this.$set(this.extraData, "firmware_ver", this.setData.firmware_ver);
      this.$set(this.extraData, "id", this.setData.id);
      this.$set(this.formModel, "sdk", this.setData.firmware_url);
      this.$set(this.formModel, "byte", this.setData.firmware_size);
      this.$set(this.formModel, "id", this.setData.id);

      if (this.formModel.is_file === 1) {
        this.defaultFileList.push({
          name: this.setData.firmware_url,
          url: this.setData.firmware_url
        });
      }

      if (this.setData.change_log) {
        var change_log = this.setData.change_log;

        if (change_log.zh) {
          this.$set(this.formModel, "zh", change_log.zh);
        }

        if (change_log.en) {
          this.$set(this.formModel, "en", change_log.en);
        }
      }

      if (this.setData.model_code && this.setData.hardware_ver) {
        var selectedObject = this.model_codeData.find(function (item) {
          return item.model_code === _this5.setData.model_code;
        });
        this.product_type_code = selectedObject.product_type_code;
        this.getxmhData();
      }
    } else {
      if (this.model_code) {
        this.$set(this.formModel, "model_code", this.model_code);
        this.$set(this.extraData, "model_code", this.model_code);
      }
    }
  }
};